export default {
  translations: [],
  pagination: {},
  translation: {},
  groups: []
}
